<template>
  <div>
    <div class="top">
      <div class="plan" @click="cancel">广告计划</div>
      <div>></div>
      <div class="new" v-text="(type === 'add' ? '新建' : '编辑') + '广告计划'"></div>
    </div>
    <div class="create-plan">
      <el-form label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="广告计划名称" prop="title">
          <el-input v-model="form.title" style="width: 320px;" placeholder="请输入广告计划名称" show-word-limit maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="总预算">
          <el-radio-group v-model="form.total_type">
            <el-radio v-model="form.total_type" label="1" border>不限</el-radio>
            <el-radio v-model="form.total_type" label="2" border>设置</el-radio>
          </el-radio-group>
          <el-input v-show="form.total_type == '2'" v-model="form.total" style="width: 120px; margin-left: 20px;" placeholder="请输入总预算"></el-input>
        </el-form-item>
        <el-form-item label="每日预算">
          <el-radio-group v-model="form.type">
            <el-radio v-model="form.type" label="1" border>不限</el-radio>
            <el-radio v-model="form.type" label="2" border>设置</el-radio>
          </el-radio-group>
          <el-input v-show="form.type == '2'" v-model="form.budget" style="width: 120px; margin-left: 20px;" placeholder="请输入每日预算"></el-input>
        </el-form-item>
        <el-form-item label="投放时间" prop="time">
          <el-date-picker v-model="form.time" type="daterange" :value-format="'yyyy-MM-dd'" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="submitForm('form', 'cancel')">保存并关闭</el-button>
          <el-button @click="cancel">取 消</el-button>
        </el-form-item>
      </el-form>
      <div class="tips">
        <div class="tips-title">温馨提示</div>
        <div class="tips-content">
          <div>计划投放时间最长30天</div>
          <div>不设置限制或者限制为0时，视为不显示预算</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'createPlan',
  props: ['plan_data'],
  data() {
    return {
      form: {
        plan_id: '',
        total_type: '1',
        total: '',
        title: '',
        type: '1',
        budget: '',
        time: ''
      },
      type: 'add',
      rules: {
        title: [
          { required: true, message: '请输入推广计划', trigger: 'blur' },
          { min: 0, max: 32, message: '长度不能超过32个字符', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请选择投放日期', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    // 编辑
    if (this.plan_data.plan_id !== undefined && parseInt(this.plan_data.plan_id) > 0) {
      this.form = {
        plan_id: this.plan_data.plan_id,
        total_type: this.plan_data.total_type + '',
        title: this.plan_data.title,
        budget: this.plan_data.budget,
        total: this.plan_data.total,
        type: this.plan_data.type + '',
        time: [this.plan_data.start_time, this.plan_data.end_time]
      };
      this.type = 'edit';
    }
    this.$function.hiddenLoading();
  },
  methods: {
    submitForm(formName, make) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.type === 'add' ? '/trader/index/createPlan' : '/trader/index/savePlan';
          this.$http.post(url, this.form).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('plan_call_back', make);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.$emit('plan_call_back', 'cancel');
    }
  }
};
</script>

<style lang="less" scoped="">
  .create-plan {
    background: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    border-radius: 4px;
    padding: 30px 20px 20px;
  }
  .top {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    height: 64px;
    font-size: 14px;
    color: #606266;
    background: #fff;
    padding: 0 25px;
    div {
      margin-right: 5px;
    }
    .plan:hover {
      cursor: pointer;
      color: #1890FF;
    }
  }
  .tips {
    padding: 30px;
    font-size: 16px;
    font-weight: 700;
    color: #9F9F9F;
    border-top: 1px solid #CFCFCF;
    .tips-content {
      margin-top: 10px;
      padding: 0 30px;
      color: #CFCFCF;
      font-size: 14px;
      font-weight: normal;
    }
  }
</style>
